import { useCallback, useState } from "react";
import { AgGrid } from "@jsq/ds/core";
import { PageWrapper } from "../components/PageWrapper";
import Titlebar from "../components/Titlebar";
import { useAgGridUtils } from "../utils/gridUtils";
import { WorkspaceRolesTable, WorkspaceRow } from "./components/WorkspaceRolesTable";
import { useFetchWorkspaceRoles } from "./hooks";
import WorkspaceRoleDetails from "./WorkspaceRoleDetails";
import { WorkspaceRoleGroupNames } from "./WorkspaceRoleDetails/components/PermissionsTab/consts";

const WorkspaceRolesPage: React.FC = () => {
  const { rowData, result } = useFetchWorkspaceRoles();
  const { onGridReady, resetFilters, isFilterPresent, onFilterChanged } = useAgGridUtils();
  const [isWpRoleDetailsOpen, setIsWpRoleDetailsOpen] = useState(false);
  const [roleName, setRoleName] = useState<WorkspaceRoleGroupNames | undefined>();

  const onRowClicked = useCallback((event: AgGrid.RowClickedEvent<WorkspaceRow>) => {
    setIsWpRoleDetailsOpen(true);
    setRoleName(event.data?.role as WorkspaceRoleGroupNames);
  }, []);

  return (
    <PageWrapper testId="workspace-roles-page" result={result}>
      <Titlebar
        marginBottom="md"
        variant="h2"
        title="Workspace roles"
        actionButtons={[
          {
            show: isFilterPresent,
            buttonProps: {
              variant: "neutral",
              icon: "times",
              key: "clear_filters",
              onClick: resetFilters,
              children: "Clear filters",
            },
          },
        ]}
      />
      <WorkspaceRolesTable
        onGridReady={onGridReady}
        rowData={rowData}
        onRowClicked={onRowClicked}
        onFilterChanged={onFilterChanged}
      />
      <WorkspaceRoleDetails
        isOpen={isWpRoleDetailsOpen}
        onClose={() => setIsWpRoleDetailsOpen(false)}
        title={roleName ?? ""}
        roleName={roleName}
      />
    </PageWrapper>
  );
};

export default WorkspaceRolesPage;
